import { RowDataDealerRebate } from "../../components/DealerRebatePage/types";
import DataDisplayRowI from "../DataDisplayRowI";

/**
 * This class should be intialized with the DealerTable factory
 */
class DealerRebateRow implements DataDisplayRowI {
    endpoint: string;
    accessData: string;

    constructor() {
        this.endpoint = "/api/admin/dealer-rebate/read-range"
        this.accessData = "rebate"
    }

    create(dealerRebate: any): RowDataDealerRebate {
        const rowData: RowDataDealerRebate = {
            id: dealerRebate.id,
            uid: dealerRebate.uid,

            startDate: dealerRebate.startDate,
            endDate: dealerRebate.endDate,
            percentage: dealerRebate.percentage,
            amount: dealerRebate.amount,
            createdAt: dealerRebate.createdAt,
            isIssued: dealerRebate.isIssued,
        };
        return rowData;
    }

    generateParams(params: any, extra: any) {
        params["uid"] = extra.current
        return params
    }
}

let dealerRebateRow: DealerRebateRow | null = null;

export default function getDealerRebateRow(): DealerRebateRow {
    if (dealerRebateRow === null)
        dealerRebateRow = new DealerRebateRow()
    return dealerRebateRow
}